import { type CustomerListResponseOutputItemsItemCounts } from '@/api/generated';

export type LabelCounts = CustomerListResponseOutputItemsItemCounts;

export const getTotalCount = (counts: LabelCounts): number =>
  counts.annotated + counts.unannotated + counts.removed + counts.unknown;

/** Detections an annotator has decided on: every label except UNANNOTATED. */
export const getLabeledCount = (counts: LabelCounts): number =>
  getTotalCount(counts) - counts.unannotated;

/**
 * Percentage (0-100) of detections that are labeled. Capped at 99 while any
 * detection is still unannotated, so 100 always means nothing is pending.
 */
export const getCompletionRate = (counts: LabelCounts): number => {
  const total = getTotalCount(counts);
  if (total === 0) {
    return 0;
  }

  const rate = Math.round((getLabeledCount(counts) / total) * 100);
  return counts.unannotated > 0 ? Math.min(rate, 99) : rate;
};
